import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';
import { amlScreeningBasePath } from './amlScreeningPaths';
import { useAmlScreeningErrorMessage } from './useAmlScreeningErrorMessage';

export const useResolveCustomerAmlScreeningHandler = (profileId) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const getErrorMessage = useAmlScreeningErrorMessage();

  return useMutation({
    mutationFn: async ({ successMessage: _successMessage } = {}) => {
      const { data } = await apiClient.post(`${amlScreeningBasePath(profileId)}/screen`);
      return data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['customers', profileId, 'aml-screening'] });
      dispatch(
        showSnackbar({
          message: variables?.successMessage || 'AML screening completed.',
          severity: 'success',
        }),
      );
    },
    onError: (error) => {
      dispatch(showSnackbar({ message: getErrorMessage(error), severity: 'error' }));
    },
  });
};
